import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  nomeAplicativo: 'Santander',
  linkCanalOficial: 'https://www.santander.com.br/renegocie/desenrola',
  mensagemColchaoNaoGerenciado: 'Todas as atualizações das negociações com o Santander devem ser acompanhadas exclusivamente através do seu portal. Nele você encontrará informações detalhadas sobre o status dos seus pagamentos.',
  mensagemAcompanhamentoAplicativo: 'Após o pagamento da primeira parcela, o restante da sua negociação poderá ser acompanhado diretamente no canal do Santander.',
  showLogoTelaBoletos: (p) => p?.parcelasGerenciadas?.demaisParcelas === false
    && (p.parcelasGerenciadas.primeiraParcela === false
      || p.parcelas?.find((b) => b.numeroParcela === 1)?.quitada === true),
};

export default rules;
